export default __webpack_public_path__ + "static/media/rotate.22b3f307.png";